import classNames from "classnames";
import {Card} from "../model/types";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import styles from "./MainWedding.module.scss";

type Props = {
    card: Card;
    className?: string;
}

export const MainWeddingCard = ({card, className}: Props) => {
    return (
        <Link href={card.link} className={classNames(styles.card, className)}>
            {card.text && (
                <p className={styles.text}>{card.text}</p>
            )}
            <Picture
                src={card.path}
                srcMobile={card.mobilePath}
                alt={card.alt}
                classes={{root: styles.carouselInner}}
            />
        </Link>
    );
}
